// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedTournaments_container__3ZC6X","line":"FeaturedTournaments_line__y9HVx","errorComponent":"FeaturedTournaments_errorComponent__2kjbJ"};